import { Roles } from 'src/common/types'
import type { RouteRecordRaw } from 'vue-router'

export const attendance: RouteRecordRaw = {
  name: 'admin.attendance',
  path: '',
  component: () => import('src/pages/AttendanceGateway.vue'),
  meta: {
    roles: [
      Roles.CenterAdmin,
      Roles.OfficeStaff,
      Roles.OrgAdmin,
      Roles.RoomStaff,
      Roles.SuperAdmin,
    ],
    supportedPlatforms: ['desktop', 'mobile', 'native'],
    excludeEnv: [],
  },
}
